import * as React from 'react';

export const NextChevron = ({
  height = '43px',
  width = '25px',
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const { stroke } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M3.625 39.25L21.375 21.5L3.625 3.75"
        stroke={stroke ? stroke : 'black'}
        strokeWidth="5.91667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
